<template>
  <Main>
    <div slot="main" class="main">
      <div class="bank_title">
        <Header :data='headerInfo'></Header>
        <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png" alt=""><span>返回</span>
        </div>
      </div>
      <div class="content" v-if="refreShow">
        <div class="left">
          <div class="server" @click="jumpClick(1)">
            <div>
              <span class="card_">产业电商交易</span>
              <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
            </div>
          </div>
          <div class="money">
            <span>GMV累计交易金额{{ headDate != '/nmzlqlogin' ? '(亿)' : '(万)' }}</span>
            <ul>
              <li v-for="(item, i) in commerceTrans.GMVTotalAmount" :key="i" :class="{ round: item == '.' }">{{ item }}
              </li>
            </ul>
          </div>
          <div class="people">
            <div class="p_item">
              <img src="../../assets/商城供应商.png" alt="">
              <div class="people_">
                <span>{{ commerceTrans.mallSupplier }}</span>
                <span>商城供应商(家)</span>
              </div>
            </div>
            <div class="p_item" style="margin-top:.71rem">
              <img src="../../assets/已入驻牛超市(家).png" alt="">
              <div class="people_">
                <span>{{ commerceTrans.enterCowSupermarket }}</span>
                <span>已入驻牛超市(家)</span>
              </div>
            </div>
          </div>
          <div class="server" @click="jumpClick(2)" style="margin-top:.89rem">
            <div>
              <span class="card_">屠宰加工</span>
              <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
            </div>
          </div>
          <div class="money">
            <span>屠宰累计交易金额{{ headDate != '/nmzlqlogin' ? `(亿)` : '(万)' }}</span>
            <!-- (${slaughterData.unitName}) -->
            <ul>
              <li v-for="(item, i) in slaughterData.totalTransAmount" :key="i" :class="{ round: item == '.' }">{{
                item
              }}</li>
            </ul>
          </div>
          <div class="people" style="margin-top:.68rem">
            <div class="p_item">
              <img src="../../assets/屠宰加工企业.png" alt="">
              <div class="people_">
                <!-- <span>{{ slaughterData.companyNum }}</span> -->
                <span>23</span>
                <span>屠宰加工企业(家)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="center_top">
            <div class="top_item">
              <span>{{ headDate != '/nmzlqlogin' ? '区域合伙人(个)' : '社会化服务' }}</span>
              <div class="small_big">
                <!-- {{ areaPartner.areaPartnerCount }} -->
                <dv-digital-flop :config="config3" style="margin-top: 0.2rem;" />
                <div class="top_box"></div>
              </div>
              <span class="add">本月新增 {{ areaPartner.monthIncrease }}</span>
            </div>
            <div class="top_item">
              <span>畜牧科技师(人)</span>
              <div class="small_big">
                <!-- {{ rearLivestockMaster.masterCount }} -->
                <dv-digital-flop :config="config2" style="margin-top: 0.2rem;" />
                <div class="top_box"></div>
              </div>
              <span class="add">本月新增 {{ rearLivestockMaster.monthIncrease }}</span>
            </div>
            <div @click="jumpBtn" class="top_item">
              <span>服务养殖户(家)</span>
              <div class="small_big">
                <!-- {{ serviceFarmer.farmerCount }} -->
                <dv-digital-flop :config="config1" style="margin-top: 0.2rem;" />
                <div class="top_box"></div>
              </div>
              <span class="add">今日新增 {{ serviceFarmer.todayIncrease }}</span>
            </div>
          </div>
          <div class="map_box">
            <div id="map" v-if="isShowMap"></div>
            <div class="turn">
              <img @click="btn" src="../../assets/left_map.png" alt="">
              <div>
                <span class="move" v-for="(item, i) in arr" :key="i">{{ item }}</span>
                <!-- <span class="move">存栏活畜分布</span>
                <span class="move">养殖户分布</span> -->
              </div>
              <img @click="btn" src="../../assets/right_map.png" alt="">
            </div>
          </div>
          <div class="footer">
            <div class="num_item" :style="{ marginLeft: headDate != '/nmzlqlogin' ? '0' : '0.7rem' }">
              <ul>
                <li v-for="(item, i) in cowBreedingStockQuantity" :key="i">{{ item }}</li>
              </ul>
              <span>牛只当前存栏量(头)</span>
            </div>
            <!-- <div class="num_item" style="margin-left:0.89rem" v-show="this.headDate != '/nmzlqlogin'">
              <ul>
                <li v-for="(item, i) in sheepBreedingStockQuantity" :key="i">{{ item }}</li>
              </ul>
              <span>羊只当前存栏量(只)</span>
            </div> -->
          </div>
        </div>
        <div class="right">
          <div class="server" @click="jumpClick(3)">
            <div>
              <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
              <span class="card_">金融服务</span>
            </div>
          </div>
          <div class="money money_">
            <span>{{ headDate != '/nmzlqlogin' ? '累计监管金额(亿)' : '监管金额(万)' }}</span>
            <ul>
              <!-- :class="{ round: item == '.' }" -->
              <li v-for="(item, i) in financialService.superviseAmount" :key="i" :class="{ round: item == '.' }">{{
                item
              }}</li>
            </ul>
          </div>
          <div class="people">
            <div class="p_item">
              <div class="people_">
                <span>{{ financialService.cooperativeBank }}</span>
                <span>合作银行机构</span>
              </div>
              <img src="../../assets/合作银行.png" alt="">
            </div>
            <div class="p_item" style="margin-top:.71rem">
              <div class="people_">
                <span>{{ financialService.cooperativeInsuranceCompany }}</span>
                <span>合作保险公司机构</span>
              </div>
              <img src="../../assets/合作保险公司.png" alt="">
            </div>
          </div>
          <div class="server" @click="jumpClick(4)" style="margin-top:.89rem">
            <div>
              <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
              <span class="card_">全流程质量追溯</span>
            </div>
          </div>
          <div class="money money_">
            <span>溯源码累计发放(万个)</span>
            <ul>
              <!-- :class="{ round: item == '.' }" -->
              <li v-for="(item, i) in qualityTraceability.traceSourceGiveOut" :key="i" :class="{ round: item == '.' }">
                {{ item }}</li>
            </ul>
          </div>
          <div class="people" style="margin-top:.68rem">
            <div class="p_item">
              <div class="people_">
                <span v-if="goBackShow">30.24</span>
                <span v-else>{{ qualityTraceability.customerSumCheck }}</span>
                <span>消费者累计核验(万次)</span>
              </div>
              <img src="../../assets/消费者累计核验.png" alt="">
            </div>
          </div>
        </div>
        <video src="../../assets/operate_bg.mp4" muted autoplay="autoplay" loop="loop"></video>
      </div>
    </div>
  </Main>
</template>

<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";
// import XChart from "../../components/XChart.vue";
// import HighCharts from 'highcharts'
// import Highcharts3D from 'highcharts/highcharts-3d';
// Highcharts3D(HighCharts);
export default {
  components: {
    Main,
    Header,
    // XChart
  },
  data() {
    return {
      dataInfo: {},
      chart: null,
      num: 0,
      isShowMap: true,
      region: {},
      headerInfo: {},
      userInfo: {},
      commerceTrans: {}, // 产业电商交易
      packinghouse: {}, // 屠宰加工
      serviceFarmer: {}, // 服务养殖户
      rearLivestockMaster: {}, // 畜牧科技师
      areaPartner: {}, // 区域合伙人
      financialService: {},// 累计监管金额
      qualityTraceability: {}, // 质量溯源
      cowBreedingStockQuantity: 0, // 牛只存栏量(头)
      sheepBreedingStockQuantity: 0, // 羊只存栏量(只)
      mapData: [],//养殖户地图
      farmerDis: {},
      breedLivestockDis: {},//存栏活畜地图数据
      arr: ['养殖户分布', '存栏活畜分布'],
      // all: '',
      goBackShow: false,//上一层
      config1: {},
      config2: {},
      config3: {},
      num1: 0,
      num2: 0,
      adcode: '',//传adcode拿下钻地图json
      paramsName: '',//下钻保存的省名
      refreShow: true,
      headDate: '',//判断是否为正蓝旗登录
      slaughterData: {},//屠宰加工数据

      mapDistance:90, //地图缩放距离
      mapDistance2:140 //子地图缩放距离
    };
  },
  watch: {},
  created() {
    this.headDate = window.localStorage.getItem('LOGIN')
    this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
  },
  mounted() {
    // 新接口屠宰加工部分
    this.getSlaughter()
    this.getData()
  },
  methods: {
    // 返回上一层
    goBack() {
      this.goBackShow = false
      this.refreShow = false
      this.$nextTick(() => {
        this.refreShow = true
        this.getData()
      })
      // this.$router.go(0)
    },
    jumpClick(type) {
      switch (type) {
        case 1:
          this.$router.push({ name: 'transactionXn' })
          break;
        case 2:
          // this.$router.push({ name: 'slaughterXn' })
          break;
        case 3:
          this.$router.push({ name: 'financialXn' })
          break;
        case 4:
          this.$router.push({ name: 'traceIndexXn' })
          break;
        default:
          this.$router.go(0)
      }
    },
    btn() {
      this.$nextTick(() => {
        // var moves = document.querySelectorAll('.move')
        // console.log(moves);
        // moves.forEach(item => {
        //   item.style.transform = "translateX(-2rem)"
        //   item.style.transition = 'transform 1s'
        // })
        var a = this.arr[0]
        this.arr.push(a)
        this.arr.splice(0, 1)

        if (this.arr[0] == '养殖户分布') {
          if (this.chart != null && this.chart != "" && this.chart != undefined) {
            this.isShowMap = false
            this.chart.dispose()
          }
          this.$nextTick(() => {
            this.isShowMap = true
            setTimeout(() => {
              if (!this.goBackShow) {
                this.mapData = this.farmerDis
              } else {
                // this.mapData = this.dataInfo.mapData.farmerDis
                this.dataInfo = this.farmerDis.filter(item => {
                  return this.paramsName == item.name
                })
                this.mapData = this.dataInfo[0].mapData.farmerDis
              }
              this.switchMap()
            }, 100)
          })
        } else {
          if (this.chart != null && this.chart != "" && this.chart != undefined) {
            this.isShowMap = false
            this.chart.dispose()
          }
          this.$nextTick(() => {
            this.isShowMap = true
            setTimeout(() => {
              if (!this.goBackShow) {
                this.mapData = this.breedLivestockDis
              } else {
                this.dataInfo = this.breedLivestockDis.filter(item => {
                  return this.paramsName == item.city
                })
                this.mapData = this.dataInfo[0].mapData.farmerDis
                // this.mapData = this.breedLivestockDis

                // this.mapData = this.dataInfo.mapData.farmerDis
              }
              this.switchMap()
            }, 100)
          })
        }

      })
      // setTimeout(() => {
      //   var moves = document.querySelectorAll('.move')
      //     moves.forEach(item => {
      //       item.style.transform = "translateX(0)"
      //     })
      //   },0)

      // if (val == 'left' && this.num > 0) {
      //   this.num >= 1 ? this.num = 0 : this.num--
      //   moves.forEach(item => {
      //     item.style.transform = "translateX(-2rem)"
      //     item.style.transition = 'transform 1s'
      //   })
      // }
      // if (val == 'right' && this.num < 1) {
      //   this.num >= 1 ? this.num = 1 : this.num++
      //   moves.forEach(item => {
      //     item.style.transform = "translateX(0)"
      //     item.style.transition = 'transform 1s'
      //   })
      // }

    },
    // 地图切换
    switchMap() {
      // if (this.region.features[0].properties.country == '正蓝旗') {
      //   this.draws(this.region, this.mapData)
      // } else {
      //   this.draw(this.region, this.mapData)
      // }
      if (this.headDate == '/nmzlqlogin') {
        this.draws(this.region, this.mapData)
      } else {
        this.draw(this.region, this.mapData)
      }
    },
    // 页面跳转
    jumpBtn() {
      this.$router.push({ name: 'breederXn' })
    },
    getSlaughter() {
      this.$http({
        url: 'mesapp-service/showScreen/home/singleCount',
        //请求方式
        method: 'post',
        //传递的参数
        data: {
          "materialsType": null
        },
      }).then(res => {
        const data = res.data
        if (res.data.code === 200) {
          this.slaughterData = data.result
          this.slaughterData.totalTransAmount = 3.83
          this.slaughterData.totalTransAmount = String(this.slaughterData.totalTransAmount).split('')
        }
      })
    },
    getData() {
      this.$http({
        url: 'screenapp-service//baseBigScreen/select',
        //请求方式
        method: 'post',
        //传递的参数
        data: {
          deptId: this.userInfo.dept.deptId,
          "parentId": "0",
          "menuMark": "10"
        },
      }).then(res => {
        const data = res.data
        if (res.data.code === 200) {
          const screenData = JSON.parse(data.result.screenData)
          console.log(screenData, '6666666666');
          window.localStorage.setItem('screenName', data.result.screenName)
          this.headerInfo = {
            name: window.localStorage.getItem('screenName')
          }
          this.dataInfo = screenData
          this.getDataList()
          this.mapData = this.dataInfo.mapData.farmerDis
          this.farmerDis = this.dataInfo.mapData.farmerDis
          this.breedLivestockDis = this.dataInfo.mapData.breedLivestockDis
          if(this.dataInfo.mapDistance){
            this.mapDistance = Number(this.dataInfo.mapDistance);
          }
          this.getMap()
        }
      })
    },
    getMap() {
      this.$http({
        url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
        //请求方式
        method: 'post',
        //传递的参数
        data: {
          deptId: this.userInfo.dept.deptId,
        },
      }).then(res => {
        if (res.data.code === 200) {
          this.region = res.data.result.json;
          // this.region.features.forEach(item => {
          //   if (item.properties.country == '正蓝旗') {
          //     console.log(111);
          //   }
          // })
          if (this.region.features[0].properties.country == '正蓝旗') {
            this.draws(this.region, this.mapData)
          } else {
            this.draw(this.region, this.mapData)
          }
        }
      })
    },
    // 获取页面数据
    getDataList() {
      this.dataInfo.commerceTrans.GMVTotalAmount = String(this.dataInfo.commerceTrans.GMVTotalAmount).split('')
      this.commerceTrans = this.dataInfo.commerceTrans
      // this.dataInfo.packinghouse.slaughterAcqAmount = String(this.dataInfo.packinghouse.slaughterAcqAmount).split('')
      // this.packinghouse = this.dataInfo.packinghouse
      this.serviceFarmer = this.dataInfo.serviceFarmer
      this.rearLivestockMaster = this.dataInfo.rearLivestockMaster
      this.areaPartner = this.dataInfo.areaPartner
      this.dataInfo.financialService.superviseAmount = String(this.dataInfo.financialService.superviseAmount).split('')
      this.financialService = this.dataInfo.financialService
      this.dataInfo.qualityTraceability.traceSourceGiveOut = String(this.dataInfo.qualityTraceability.traceSourceGiveOut).split('')
      this.qualityTraceability = this.dataInfo.qualityTraceability
      this.cowBreedingStockQuantity = String(this.dataInfo.cowBreedingStockQuantity).split('')
      this.sheepBreedingStockQuantity = String(this.dataInfo.sheepBreedingStockQuantity).split('')
      if (this.headDate == '/nmzlqlogin') {
        this.dataInfo.commerceTrans.GMVTotalAmount = ['1', '8', '0']
        this.commerceTrans.mallSupplier = 32
        this.rearLivestockMaster.masterCount = 18
        this.serviceFarmer.farmerCount = 304
        this.dataInfo.financialService.superviseAmount = ['8', '9', '0', '0']
      }
      this.config1 = {
        number: [0],
        style: {
          //这里可以修改默认样式
          fontSize: 64,//字体大小
          fill: '#FFE11D',//字体颜色
          fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
        }
      }
      this.config2 = {
        number: [0],
        style: {
          //这里可以修改默认样式
          fontSize: 64,//字体大小
          fill: '#FFE11D',//字体颜色
          fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
        }
      }
      this.config3 = {
        number: [0],
        style: {
          //这里可以修改默认样式
          fontSize: 64,//字体大小
          fill: '#FFE11D',//字体颜色
          fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
        }
      }
      setTimeout(() => {
        this.serviceFarmer.farmerCount = 17579
        this.config1 = {
          number: [this.serviceFarmer.farmerCount],
          style: {
            //这里可以修改默认样式
            fontSize: 64,//字体大小
            fill: '#FFE11D',//字体颜色
            fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
          }
        }
        this.config2 = {
          number: [this.rearLivestockMaster.masterCount],
          style: {
            //这里可以修改默认样式
            fontSize: 64,//字体大小
            fill: '#FFE11D',//字体颜色
            fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
          }
        }
        this.config3 = {
          number: [this.areaPartner.areaPartnerCount],
          style: {
            //这里可以修改默认样式
            fontSize: 64,//字体大小
            fill: '#FFE11D',//字体颜色
            fontFamily: '汉仪菱心体简-regular, 汉仪菱心体简',
          }
        }
      }, 0)
    },
    changeMap() {
      this.$http({
        url: 'screenapp-service/map/child/data',
        //请求方式
        method: 'post',
        //传递的参数
        data: {
          adcode: this.adcode,
        },
      }).then(res => {
        if (res.data.code === 200) {
          // this.region = res.data.result.json;
          // console.log(res.data.result.map, ' res.data.result.json');
          if (this.chart != null && this.chart != "" && this.chart != undefined) {
            this.isShowMap = false
            this.chart.clear()
          }
          this.$nextTick(() => {
            this.isShowMap = true
            this.$nextTick(() => {
              this.goBackShow = true
              this.region = res.data.result.map
              this.draw(this.region, this.mapData)
              this.getDataList()
            })
          })

          // this.getData()
        }
      })
    },
    // 正蓝旗
    draws(geoJson) {
      // console.log(geoJson,'geoJson');
      // console.log(geoJson, 234);
      // console.log(data, 123);
      // 基于准备好的dom，初始化echarts实例
      this.chart = this.$echarts.init(document.getElementById("map"));
      this.$echarts.registerMap('GD', geoJson);
      let data = [
        ['116.158430112977', '42.8426140522395', 260],//赛音呼都嘎苏木乡
        ['115.887591014485', '42.9047850462557', 286],//那日图苏木乡
        ['115.936932911947', '41.9696109107532', 224],//黑城子示范区
        ['115.580376925441', '42.8669839246449', 287],//扎格斯台苏木乡
        ['115.641299118031', '42.2547129144455', 454],//哈毕日嘎镇
        ['115.613881921393', '42.5079359815629', 234],//宝绍代苏木乡
        // ['115.724337808832', '42.2433489074685', 500],//上都镇
        // ['115.764337808832', '42.2833489074685', 490],//上都镇
        ['115.904337808832', '42.3033489074685', 480],//上都镇
        ['115.864337808832', '42.2433489074685', 500],//上都镇
        ['116.231843112159', '42.3435590074122', 310],//五一种畜场总场
        ['115.893910088668', '42.580423003749', 341],//桑根达来镇
      ];
      let areaData = [];
      data.map((item) => {
        // 扩大热力图效果
        areaData.push(...new Array(4).fill(item));
      });
      let mapMax = Math.max(...data.map((item) => item[2]));
      let mapMin = Math.min(...data.map((item) => item[2]));


      var option = {
        tooltip: {
          label: {
            show: false,
          },
          textStyle: {
            color: '#fff'
          },
          // 提示框
          trigger: "item",
          borderColor: "#00E0DB",
          borderWidth: 1,
          padding: 5,
          backgroundColor: "#030b14",
          extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
          formatter: (params) => {
            // console.log(params, 'params');
            return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
          },
        },
        visualMap: {
          type: 'continuous',
          show: true,
          calculable: false,
          right: 30,
          bottom: 20,
          itemWidth: 13,//图形的宽度，即长条的宽度。
          itemHeight: 80,
          // showLabel: !0,
          text: [`${mapMax}`, '0'],
          // realtime: false,
          // calculable: true,
          color: ['#fa0023', '#84d100', '#90ff07', '#edcc00', '#004684'],
          min: mapMin,
          max: mapMax,
          // continuous: {
          //     type: 'piecewise',
          // itemGap: 12,
          align: 'left',
          // itemSymbol: 'circle',
          // itemWidth: 8,
          // itemHeight: 8,
          textStyle: { color: '#fff' },
        },

        grid: {
          height: '100%',
          width: '100%',
        },

        geo: [
          {
            map: 'GD',
            top: 'center',
            left: '30%',
            roam: false,
            // width: '90%',
            // height: '95%',
            zoom: 1,
            // z: 1,
            label: {
              normal: {
                show: false,
                color: 'transparent',
                fontSize: 22,
              }
            },
            emphasis: {
              // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
              label: {
                // label高亮时的配置
                show: false,
                textStyle: {
                  color: "#fff", // 高亮时标签颜色变为 白色
                  fontSize: 15, // 高亮时标签字体 变大
                },
                // formatter: function (params) {
                //   // console.log(params)
                //   return params.name
                // }
              },
              itemStyle: {
                "areaColor": "#1E88E5"
              }
            },
            itemStyle: {
              // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
              // color: "rgba(33,80,231,1)", // 地图板块的颜色
              color: '#0f3a67',
              opacity: 1, // 图形的不透明度 [ default: 1 ]
              borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
              borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
              normal: { // 默认地图区域样式
                // areaColor: 'rgba(33,80,231,1)',
                areaColor: "#0f3a67",
                // borderColor: "#4ECEE6",
                borderColor: "#165d7d",
                borderWidth: 1,
                // shadowColor: "#2C99F6",
                // shadowOffsetY: 0,
                // shadowBlur: 25,
              },
            },
          },
        ],

        series: [
          {
            mapType: 'GD',
            name: 'AQI',
            type: 'heatmap',
            coordinateSystem: 'geo',
            data: areaData
          },

        ],
      }
      this.chart.clear();
      this.chart.setOption(option);
      // chart.on('click', (ret) => {
      //     console.log(ret,'wodianle');
      // })
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    // 地图
    draw(geoJson, data) {
      this.num = 0
      var mapValue = [
        { name: '内蒙古自治区', value: 10 },
        { name: '四川省', value: 1 },
        { name: '云南省', value: 2 },
        { name: '吉林省', value: 3 },
      ]
      this.chart = this.$echarts.init(document.getElementById("map"));
      // geoJson.features.forEach((item) => {     
      //     item['properties']['cp'] = item.properties.center
      // })
      this.$echarts.registerMap("bayannaoer", geoJson);
      this.chart.hideLoading();
      // 隐藏动画加载效果。
      var option = {
        legend: false,
        tooltip: {
          show: true,
          // 提示框
          trigger: "item",
          borderColor: "#00E0DB",
          borderWidth: 1,
          padding: 5,
          backgroundColor: "#030b14",
          extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
          formatter: function (params) {
            const valueId = mapValue.find((item) => {
              return params.name == item.name
            }) || {}
            // console.log(params, 'params');
            // if () {

            // }
            return `
                        <p style="color:#00E0DB;font-size: 20px;">${params.data.name}</p><br/>
                        <p>
                       <span style="color: #FFF; font-size: 14px; font-weight: normal;">区域合伙人
                        <span style="color: #00E0DB; font-size: 16px;">${valueId.value || 0}
                          </span><span style="color: #fff; font-size: 16px; font-weight: normal;">个</span> </span>
                              </p>
                              `;
            // <p>
            //   <span style="color: #FFF; font-size: 14px; font-weight: normal;">畜牧科技师服务养殖户占比<span style="color: #00E0DB; font-size: 16px;">${params.data.proportion || 0}</span></span>
            // </p>
            // return params.name
          },
        },
        grid: {
          // top: '-5%',
          // show: true,
          // height:'700px'
        },
        series: [
          {
            type: "map3D", // 系列类型
            name: "map3D", // 系列名称
            zoom: 1,
            // aspectScale: 1.2, //长宽比
            map: "bayannaoer", // 地图 类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            data: [
              {
                name: '四川省',
                itemStyle: {
                  normal: {
                    color: '#087b96'
                  }
                }
              },
              {
                name: '吉林省',
                itemStyle: {
                  normal: {
                    color: '#087b96'
                  }
                }
              },
              {
                name: '云南省',
                itemStyle: {
                  normal: {
                    color: '#087b96'
                  }
                }
              },
              {
                name: '内蒙古自治区',
                itemStyle: {
                  normal: {
                    color: '#087b96'
                  }
                }
              },
            ],
            top: '18%',
            left: '-5%',
            // bottom:'50%',
            label: {
              // properties.cp
              // 标签的相关设置
              show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
              // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
              position: 'top',
              // offset: [-10, 5],
              textStyle: {
                // 标签的字体样式
                color: "white", // 地图初始化区域字体颜色
                fontSize: 12, // 字体大小
                opacity: 1, // 字体透明度
                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
              },
              // align: 'center',
              // verticalAlign: 'middle'
              // normal: {
              //     show: true,
              //     color: 'rgba(5, 176, 220, 1)',
              //     fontSize: 1, //此处字体需做兼容适配

              //     align: 'left',
              //     verticalAlign: 'middle',
              //     position: 'inside',
              //     distance: 15,
              // },
              // emphasis: {
              //     show: true,
              //     color: '#ececec'
              // }
            },
          
            itemStyle: {
              // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
              // color: "rgba(33,80,231,1)", // 地图板块的颜色
              color: '#17478F',
              opacity: 1, // 图形的不透明度 [ default: 1 ]
              borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
              borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
            },

            emphasis: {
              // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
              label: {
                // label高亮时的配置
                show: false,
                textStyle: {
                  color: "#fff", // 高亮时标签颜色变为 白色
                  fontSize: 15, // 高亮时标签字体 变大
                },
                // formatter : function(params) {
                //     console.log(params)
                // }
              },
              itemStyle: {
                "color": "#00E0DB"
              }
            },
            groundPlane: {
              // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
              show: false, // 是否显示地面。[ default: false ]
              color: "#aaa", // 地面颜色。[ default: '#aaa' ]
            },
            light: {
              // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
              main: {
                // 场景主光源的设置，在 globe 组件中就是太阳光。
                color: "#fff", //主光源的颜色。[ default: #fff ]
                intensity: 1.2, //主光源的强度。[ default: 1 ]
                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
              },
            },

            viewControl: {
              // 用于鼠标的旋转，缩放等视角控制。
              projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
              autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
              autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
              autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
              autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
              damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
              rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
              zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
              panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
              panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
              rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
              orthographicSize: 60,
              // distance: 200, 
              distance: this.mapDistance, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
              minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
              maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
              alpha: 70, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
              beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]  60
              // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
              // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
              // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
              // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
              // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
              animation: true, // 是否开启动画。[ default: true ]
              animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
              animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
            },
          },
        ],
        visualMap: {
          show: false,
          type: 'continuous',
          // show: true,
          // min: 0,
          // max: this.num1 ? this.num1 * 4 : 0, //控制根据返回值  控制数量
          right: 50,
          bottom: 20,
          itemWidth: 13,//图形的宽度，即长条的宽度。
          itemHeight: 80,
          // showLabel: !0,
          text: [`${this.num2}`, '0'],
          // realtime: false,
          // calculable: true,
          // handleIcon: "circle",
          // handleSize: '100%',
          // handleStyle: {
          //   borderWidth: 0,
          //   opacity:1
          // },
          inRange: {
            color: this.num2 ? ['rgba(16,53,95,0.4)', 'rgba(250,219,114,1)', 'rgba(244,165,47,1)',
              'rgba(242,150,43,1)', 'rgba(247,130,24,1)', 'rgba(249,105,33,1)'] : ['rgba(16,53,95,0.4)']  //显示颜色
          },
          // indicatorStyle:{
          //     color:'red',
          //     borderWidth:0,
          //     borderColor :'yellow',
          //   },  //指示器
          // continuous: {
          //     type: 'piecewise',
          // itemGap: 12,
          align: 'left',
          // itemSymbol: 'circle',
          // itemWidth: 8,
          // itemHeight: 8,
          textStyle: { color: '#fff' },
          pieces: [{
            gte: this.num1 * 4,
            label: `${this.num1 * 4}以上`,
            // color: "#6b3e35"
            color: "#f96921",
            opacity: 1
          }, {
            gte: this.num1 * 3,
            lte: this.num1 * 4,
            label: `${this.num1 * 3} - ${this.num1 * 4}`,
            color: "#f78218",
            opacity: 1
            // color: "#4a383f"
          },
          {
            gte: this.num1 * 2,
            lte: this.num1 * 3,
            label: `${this.num1 * 2}-${this.num1 * 3}`,
            color: "#f2962b",
            opacity: 1
            // color: "#303345"
          }, {
            gte: this.num1,
            lte: this.num1 * 2,
            label: `${this.num1}-${this.num1 * 2}`,
            color: '#f4a52f',
            opacity: 1
            // color: "#192f4d"
          }, {
            gte: 1,
            lte: this.num1,
            label: `1-${this.num1}`,
            // color: "#112e50"
            color: "#fadb72",
            opacity: 1
          }, {
            gte: 0,
            lte: 0,
            // color: "#112e50"
            color: "#10355F",
            opacity: .4,
          }
          ],
          // },



        },
      };
      this.chart.clear()
      // setTimeout(() => {

      // }, 100)

      this.chart.setOption(option)

      window.addEventListener('resize', () => {
        this.chart.resize()
      })
      var num_ = 0
      // this.chart.on('click', (params) => {
      //   num_++
      //   if (num_ == 1) {
      //     this.region.features.forEach((item) => {
      //       if (item.properties.name == params.name) {
      //         var a = this.mapData.filter(item => {
      //           if (item.name == params.name) {
      //             this.paramsName = params.name
      //             return item
      //           }
      //         })
      //         this.dataInfo = a[0]
      //         this.adcode = item.properties.adcode
      //         this.mapData = this.dataInfo.mapData.farmerDis
      //         this.changeMap()
      //       }
      //     })
      //   } else {
      //     return
      //   }
      //   // if (params.name == '锡林郭勒盟') {

      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;

  .bank_title {
    position: relative;

    .gobcak {
      width: .875rem;
      height: .4375rem;
      position: absolute;
      z-index: 99;
      bottom: -0.3rem;
      left: 0.25rem;
      font-size: .2rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #00E0DB;
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        width: .3rem;
        height: .3rem;
      }

      span {
        margin-left: .05rem;
      }
    }
  }

  .content {
    position: relative;
    padding: 0.53rem .26rem 0.48rem .25rem;
    box-sizing: border-box;
    min-height: 12.5rem;
    // min-height: calc(100vh - 1rem);
    // background-image: url("../../assets/bg-hhr.png");
    // background-size: 100% 100%;
    display: flex;

    video {
      position: absolute;
      top: 78px;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
    }

    .left {
      width: 4.25rem;
      // display: flex;
      margin-top: .87rem;
    }

    .center {
      width: 15.5rem;

      // background-color: yellow;
      .center_top {
        width: 100%;
        display: flex;
        justify-content: center;

        .top_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: .91rem;
          cursor: pointer;

          span {
            font-size: 0.23rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            padding-bottom: .24rem;
          }

          .add {
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00FF9D;
            margin-top: .11rem;
          }

          .small_big {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 3rem;
            height: 1rem;
            background: rgba(0, 223, 218, 0.08);
            opacity: 1;
            font-size: 0.8rem;
            font-family: 汉仪菱心体简-regular, 汉仪菱心体简;
            font-weight: 400;
            color: #FFE11D;
            position: relative;

            &::after {
              position: absolute;
              left: 0;
              top: 0;
              content: "";
              width: 0.13rem;
              height: 0.13rem;
              opacity: 1;
              border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
              border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
            }

            &::before {
              position: absolute;
              right: 0;
              top: 0;
              content: "";
              width: 0.13rem;
              height: 0.13rem;
              opacity: 1;
              border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
              border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
            }

            .top_box {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: .3rem;

              &::after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: 0.13rem;
                height: 0.13rem;
                opacity: 1;
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
              }

              &::before {
                position: absolute;
                right: 0;
                bottom: 0;
                content: "";
                width: 0.13rem;
                height: 0.13rem;
                opacity: 1;
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
              }
            }
          }
        }

        .small_big:hover {
          // background-color:red
          // box-shadow:5px 5px 10px #1d394c;
          // transition: all .5s linear;
          margin-top: 0px;
          /*和hover的margin-top有对比，原无30,现在0，相当于上移了,30px*/
          // box-shadow: 2px 2px 2px 2px #918f8f;
          /*盒子阴影*/
          background: rgba(0, 224, 219, 0.1);
          box-shadow: 0rem 0rem 0.25rem 0rem rgba(30, 231, 231, 0.4), inset 0rem 0rem 0.25rem 0rem rgba(30, 231, 231, 0.4);
          opacity: 1;
          transform: translateY(-5px);
          transition: all 0.5s;
          /*持续时间*/

        }

        .top_item:nth-child(1) {
          margin-left: 0;
        }
      }

      .map_box {
        height: 8.1rem;
        // margin-top: .25rem;
        background: url('../../assets/bg_map.png');
        background-size: 100% 100%;

        #map {
          width: 13.5rem;
          height: 7.2rem;
          margin: auto;
        }

        .turn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          min-height: 0.6rem;
        }

        img {
          width: .32rem;
          height: .32rem;
          cursor: pointer;
        }


        div {
          width: 2rem;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          margin: 0 .37rem;
          min-height: 0.6rem;
          line-height: 0.6rem;
          // span:nth-child(1) {
          //   width: 100%;
          // }

          span {
            width: 2rem;
            display: inline-block;
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #00E0DB;
            // transform: translateX(-2rem);
            // animation: move 1s linear infinite alternate;
          }


        }
      }

      .footer {
        margin-top: .2rem;
        display: flex;
        justify-content: center;
        // margin-left: 1.4rem;

        .num_item {
          display: flex;
          flex-direction: column;
          align-items: center;

          ul {
            display: flex;

            li {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 0.56rem;
              height: 0.63rem;
              background: rgba(0, 224, 219, 0.05);
              box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
              opacity: 1;
              border: 0.01rem solid rgba(0, 224, 219, 0.1);
              font-size: 0.45rem;
              font-family: Source Han Sans CN-Bold, Source Han Sans CN;
              font-weight: bold;
              color: #00E0DB;
              margin-left: .14rem;
            }

            li:nth-child(1) {
              margin-left: 0;
            }
          }

          span {
            font-size: 0.23rem;
            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: .18rem;
          }
        }
      }
    }

    .right {
      width: 4.25rem;
      margin-top: .87rem;

      .server {
        justify-content: flex-end;
        background: linear-gradient(270deg, rgba(0, 222, 217, 0.5) 0%, rgba(0, 88, 179, 0) 100%);
        border-radius: 0rem 1.25rem 1.25rem 0rem;

        img {
          transform: rotate(180deg);
        }

        // padding-top: .24rem;
        .card_ {
          padding-right: .25rem;
        }
      }

      .money {
        margin-top: .59rem;
        margin-left: 0;

        span {
          margin-left: 1.2rem;
        }

        ul {
          margin-left: 0.15rem;

        }
      }

      .money_ {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-right: 0.38rem;

        span {
          margin-left: 0;
        }

        ul {
          margin-left: 0;

        }
      }

      .people {
        margin-top: .79rem;
        // margin-right: .61rem;
        margin-left: 0;
        display: flex;
        flex-direction: column;

        .p_item {
          display: flex;
          align-items: center;
          margin-left: .9rem;

          img {
            margin-left: 0.26rem;
          }

          .people_ {
            margin-left: 0;
            text-align: right;

            span:nth-child(2) {
              min-width: 2rem;
            }
          }
        }

      }
    }

    .round {
      width: 0.15rem !important;
      height: 0.6rem !important;
      background: none !important;
      box-shadow: none !important;
      border: none !important;
      // margin: 0 .1rem !important;
      margin-top: .1rem;
    }

    .server {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // width: 6.25rem;
      height: 0.56rem;
      background: linear-gradient(-270deg, rgba(0, 222, 217, 0.5) 0%, rgba(0, 88, 179, 0) 100%);
      border-radius: 1.25rem 0rem 0rem 1.25rem;
      cursor: pointer;

      // padding-top: .24rem;
      .card_ {
        font-size: 0.23rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #00E0DB;
        padding-left: .25rem;
      }
    }

    .money {
      margin-top: .59rem;
      margin-left: .4rem;

      span {
        height: 0.3rem;
        font-size: 0.25rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.3rem;
      }

      ul {
        margin-top: .26rem;
        display: flex;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 0.56rem;
          height: 0.63rem;
          background: rgba(0, 224, 219, 0.05);
          box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
          opacity: 1;
          border: 0.01rem solid rgba(0, 224, 219, 0.1);
          margin-left: .13rem;
          font-size: 0.45rem;
          font-family: Source Han Sans CN-Bold, Source Han Sans CN;
          font-weight: bold;
          color: #00E0DB;
        }

        li:nth-child(1) // li:nth-child(5)

          {
          margin-left: 0;
        }

      }
    }

    .people {
      margin-top: .79rem;
      margin-left: .4rem;
      display: flex;
      flex-direction: column;

      .p_item {
        display: flex;
        align-items: center;

        img {
          width: 0.63rem;
          height: 0.63rem;
        }

        .people_ {
          margin-left: .26rem;
          display: flex;
          flex-direction: column;
          font-size: 0.38rem;
          font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
          font-weight: bold;
          color: #FFFFFF;

          span:nth-child(2) {
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: .25rem;
          }
        }
      }

    }
  }

}
</style>